module.exports = __webpack_public_path__ + "img/P66-zh.5195a138.png";